import React, { useState, useContext, useEffect, useRef } from 'react';
import { Button, Card, Col, Container, Modal, Nav, Row, Tab } from 'react-bootstrap';
import { Mail } from 'react-feather';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/Loader';
import NotyfContext from '../../contexts/NotyfContext';
import { fetchStartCurrent, confirmDisputeEmailed, generateLetters, blankStartCurrentScore } from '../../redux/slices/DisputeCenterSlice';
import ActiveLetter from './partials/ActiveLetter';
import InDispute from './partials/InDispute';
import Score from '../../components/new/scores';
import $ from 'jquery';
import EnhanceCurrentDisputes from '../enhance_dispute/EnhanceCurrentDisputes';
import InfoPopover from '../../components/new/InfoPopover';
import Joyride, { ACTIONS, STATUS } from 'react-joyride';
import { fetchTourProgresses, updateTourProgress } from '../../redux/slices/TourProgressSlice';
import SuccessPopup from '../../components/new/SuccessPopup';
import { useLocation, useNavigate } from 'react-router-dom';
import NavItemComponent from './NavItemComponent';
import { blankUploadDocument, setSkipDocuments } from '../../redux/slices/UploadDocumentSlice';
import UploadAllDocument from '../upload-document/UploadAllDocument';
import { blankGetAllReportData } from '../../redux/slices/ReportSlice';
import moment from 'moment';
import CountdownTemplates from '../dasboard/CountdownTemplates';
import { blankCurrentStatus, fetchCurrentStatus } from '../../redux/slices/DashboardSlice';

const DisputeCenter = () => {
  const { state } = useLocation();
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [currentRound, setCurrentRound] = React.useState(0);
  const [showUpgradeModal, setShowUpgradeModal] = React.useState(false);
  const [showGenerateRoundResult, setShowGenerateRoundResult] = React.useState(false);
  const [showDocumentsModal, setShowDocumentsModal] = React.useState(false);
  const [isDocUpload, setIsDocUpload] = React.useState(false);

  const [activeTab, setActiveTab] = React.useState("first");

  //left tab
  const [dispute_letter_left_list, setdispute_letter_left_list] = React.useState([]);
  const [active_letter, setactive_letter] = React.useState(0);
  const [completed_letter, setcompleted_letter] = React.useState(0);
  const [dispute_letter_left, setdispute_letter_left] = React.useState(0);
  const [dispute_letter_current_plan_id, setdispute_letter_current_plan_id] = React.useState(0);
  const [dispute_letter_is_emailed, setdispute_letter_is_emailed] = React.useState(null);

  //right tab
  const [dispute_letter_right_list, setdispute_letter_right_list] = React.useState([]);
  const [disputeItemCounts, setDisputeItemCounts] = React.useState({
    verified_items: 0,
    in_dispute: 0,
    deteled_letter: 0
  })
  const [dispute_letter_right, setdispute_letter_right] = React.useState(0);
  const [letterChoice, setLetterChoice] = React.useState(null);
  const [runJoyride, setRunJoyride] = React.useState(false);
  const [documentPopUp, setDocumentPopUp] = React.useState(true);

  const [currentScore, setCurrentScore] = React.useState({
    equfix: 0,
    experian: 0,
    transunion: 0,
    equfixPresentage: 0,
    experianPresentage: 0,
    transunionPresentage: 0,
    experianLabel: '',
    equfixLabel: '',
    transunionLabel: '',
  });

  const roundDates = useRef({
    start: null,
    end: null,
  });

  const [startScore, setStartScore] = React.useState({
    equfix: 0,
    experian: 0,
    transunion: 0,
    experianLabel: '',
    equfixLabel: '',
    transunionLabel: '',
  });

  const [showRoundStartPopUp, setShowRoundStartPopUp] = React.useState(false);
  const [showMailed, setShowMailed] = React.useState(false);

  const navLinkRef = useRef(null);
  const navLinkRefTwelfth = useRef(null);

  const sc_status = useSelector(state => state.disputeCenter.sc_status);
  const startCurrentScore = useSelector(state => state.disputeCenter.startCurrentScore);
  const sc_error = useSelector(state => state.disputeCenter.sc_error);

  // Tour Progresses
  const tourStatus = useSelector(state => state.tourProgress.status);
  const tours = useSelector(state => state.tourProgress.tours);

  const userCurrentInfo = useSelector(state => state.uploadDocument.uploadDocumentData);
  const uploadDocumentStatus = useSelector(state => state.uploadDocument.status);

  const currentStatusData = useSelector(state => state.dashboard.currentStatusData);
  const currentApiStatus = useSelector(state => state.dashboard.currentApiStatus);

  useEffect(() => {
    if (tourStatus === 'idle') dispatch(fetchTourProgresses());
  }, [tourStatus]);

  useEffect(() => {
    dispatch(blankStartCurrentScore());
    dispatch(blankUploadDocument());
    dispatch(blankCurrentStatus());

    if(state?.toItems) {
      setActiveTab("second")
      delete window.history?.state?.toItems;
      window.history.replaceState({}, document.title)
    }

  }, []);

  useEffect(() => {
    if (currentApiStatus === 'idle') {
      dispatch(fetchCurrentStatus());
    }
  }, [currentApiStatus, dispatch]);

  useEffect(() => {
    const notTourExists = tours.filter(tour => tour.tour_name === 'dispute-center' && tour.completed).length === 0
    if (['loading', 'idle'].includes(tourStatus)) setRunJoyride(false);
    else if  (notTourExists && !showRoundStartPopUp) setRunJoyride(true);
    else setRunJoyride(false);


    setTimeout(() => {
      if(['loading', 'idle'].includes(tourStatus) || ['loading', 'idle'].includes(sc_status)) setDocumentPopUp(true);
      else if(runJoyride || showRoundStartPopUp || notTourExists) setDocumentPopUp(true);
      else setDocumentPopUp(false);
    }, 1000);


    if(state?.toItems && sc_status === "succeeded") {
      navLinkRef.current?.click();
      delete window.history?.state?.toItems;
      window.history.replaceState({}, document.title)
    }

  }, [tours, tourStatus, showRoundStartPopUp, sc_status]);

  useEffect(() => {
    // !letterChoice && handleChoice(0);
    // !letterChoice && handleChoice(-1, 3);
    if (!letterChoice && !runJoyride && !['loading', 'idle'].includes(sc_status)) {
      const count = dispute_letter_left_list.filter(item => item.downloaded == '0').length;
      if (dispute_letter_left_list.length > 0 && dispute_letter_left_list[0].disputely_mail == '0' && count > 0 && dispute_letter_current_plan_id !== 2) {
        handleChoice(-1, count);
        // setShowConfirmMailing(2)
      } else if ((!dispute_letter_is_emailed && dispute_letter_left_list.length > 0 && dispute_letter_left_list[0].disputely_mail == '0' && dispute_letter_current_plan_id !== 2) || (!dispute_letter_is_emailed && dispute_letter_left_list.length > 0 && dispute_letter_left_list[0].disputely_mail == '0' && count > 0 && dispute_letter_current_plan_id !== 2)) {
        handleChoice(0);
        // setShowConfirmMailing(1)
      }
    }
  }, [dispute_letter_is_emailed, dispute_letter_left_list, runJoyride]);

  useEffect(() => {
    if (sc_status === 'succeeded') {
      if (startCurrentScore && Object.keys(startCurrentScore).length > 0) {
        if (startCurrentScore.error === 0) {
          // dispatch(blankStartCurrentScore());
          setStartScore({
            equfix: startCurrentScore.data.starting_score.equifax,
            experian: startCurrentScore.data.starting_score.experian,
            transunion: startCurrentScore.data.starting_score.transunion,
            experianLabel: startCurrentScore.data.starting_score.experian_label,
            equfixLabel: startCurrentScore.data.starting_score.equifax_label,
            transunionLabel: startCurrentScore.data.starting_score.transunion_label,
          });
          setCurrentScore({
            equfix: startCurrentScore.data.current_score.equifax,
            experian: startCurrentScore.data.current_score.experian,
            transunion: startCurrentScore.data.current_score.transunion,
            equfixPresentage: startCurrentScore.data.current_score.equifax_percentage,
            experianPresentage: startCurrentScore.data.current_score.experian_percentage,
            transunionPresentage: startCurrentScore.data.current_score.transunion_percentage,
            experianLabel: startCurrentScore.data.current_score.experian_label,
            transunionLabel: startCurrentScore.data.current_score.transunion_label,
            equfixLabel: startCurrentScore.data.current_score.equifax_label,
          });

          setdispute_letter_current_plan_id(eval(startCurrentScore.data.dispute_letter.current_plan_id));
          setdispute_letter_left_list(startCurrentScore.data.dispute_letter.dispute_letter_listing);
          setactive_letter(startCurrentScore.data.dispute_letter.active_letter);
          setcompleted_letter(startCurrentScore.data.dispute_letter.completed_letter);
          setdispute_letter_left(startCurrentScore.data.dispute_letter.dispute_letter);
          setdispute_letter_is_emailed(startCurrentScore.data.dispute_letter.is_emailed);
          setdispute_letter_right_list(startCurrentScore.data.dispute_items.dispute_listing_data);
          setDisputeItemCounts({
            verified_items: startCurrentScore.data.dispute_items.verified_items,
            deteled_letter: startCurrentScore.data.dispute_items.deleted_repaired_item,
            in_dispute: startCurrentScore.data.dispute_items.in_dispute_item
          })
          setdispute_letter_right(startCurrentScore.data.dispute_items.total_dispute_items);
          setCurrentRound(startCurrentScore.data.current_score.round);
        }
      }
    } else if (sc_status === 'failed') {
      notyf.open({
        type: 'danger',
        message: sc_error,
        duration: '3000',
        ripple: false,
        dismissible: false,
        position: {
          x: 'right',
          y: 'top',
        },
      });
    }else if(sc_status === 'idle') dispatch(fetchStartCurrent());
  }, [sc_status]);

  useEffect(() => {
    if (sc_status === 'succeeded' && ( showMailed || (dispute_letter_left_list.length > 0 && state?.congratulations && startCurrentScore?.data?.round_start_date))) {
      setShowRoundStartPopUp(true);
    }
  }, [sc_status, showMailed, state, dispute_letter_left_list]);

  useEffect(() => {
    if (sc_status === 'succeeded' && startCurrentScore?.data?.round_end_date && dispute_letter_left_list.length > 0 && moment(startCurrentScore?.data?.round_end_date).isBefore(moment())){
      setShowGenerateRoundResult(true);
    }
  }, [sc_status])

  const handleChoice = async (choice, count = null, date = null) => {
    setLetterChoice(1);
    switch (choice) {
      case -1:
        $.confirm({
          title: 'Letter Download!',
          content: `You still have ${count} letters that need to be downloaded.  Remember, with the free option, you have to print and mail them yourself.`,
          buttons: {
            ok: {
              text: 'Okay, Will download them now',
              btnClass: 'btn-success',
              action: () => {
                navLinkRefTwelfth.current.click();
                document.querySelector('#download-all').click();

                notyf.open({
                  type: 'success',
                  message: "Your letters have downloaded! Check them out and get them mailed!  We'll be bothering you every time you login to make sure that you have, so we can start your disputes cycle!",
                  duration: 15000,
                  ripple: false,
                  dismissible: false,
                  position: {
                    x: 'right',
                    y: 'top',
                  },
                });

                setTimeout(() => {
                  dispatch(fetchStartCurrent());
                }, 4500);
              },
            },
            mail: {
              text: 'Do it for me',
              btnClass: 'btn-primary bg-primary',
              action: () => handleChoice(3),
            },
          },
        });
        break;
      case 0:
        $.confirm({
          title: 'Have you mailed your disputes yet?',
          content: "It's important that you get your disputes printed, stuffed in envelopes with the correct bureau addresses and mailed as soon as possible!",
          buttons: {
            yes: {
              text: 'I have mailed them',
              btnClass: 'btn-success',
              action: () => handleChoice(4),
            },
            no: {
              text: "I haven't mailed them yet",
              btnClass: 'btn-danger',
              action: () => handleChoice(1),
            },
          },
        });
        break;
      case 1:
        $.confirm({
          title: 'Disputely Mailing!',
          content: 'Do you need disputely to do the mailing for you?',
          buttons: {
            yes: {
              text: 'Yes, Mail it for me',
              btnClass: 'btn-success',
              action: () => handleChoice(3),
            },
            no: {
              text: 'No, I will do it myself',
              btnClass: 'btn-danger',
              action: () => {
                // sessionStorage.setItem("skip_letter_prompt", 1)
              },
            },
          },
        });
        break;
      case 2:
        if (date) {
          await dispatch(confirmDisputeEmailed(date)).unwrap();
          dispatch(blankUploadDocument())
          dispatch(blankStartCurrentScore())
          dispatch(blankCurrentStatus())

          setShowMailed(true);
        }
        break;
      case 3:
        setShowUpgradeModal(true);

        break;
      case 4:
        $.confirm({
          title: 'What day did you mail them on?',
          content: `<div>
              This date is important because it starts the countdown before you need to access your reports again. If you didn't really mail them, it's ok, we just need to get them sent as soon as possible.
              <input type='date' id='email_date' name='email_date' class='form-control' onfocus="this.max=new Date().toISOString().split('T')[0]" />
            </div>`,
          buttons: {
            yes: {
              text: 'Submit',
              btnClass: 'btn-success',
              action: function () {
                let date = this.$content.find('#email_date').val();
                if (date && date !== '') {
                  handleChoice(2, null, date);
                } else {
                  this.$content.find('#email_date').addClass('is-invalid');
                  return false;
                }
              },
            },
            no: {
              text: 'Cancel',
              btnClass: 'btn-danger',
              action: () => {
                // sessionStorage.setItem("skip_letter_prompt", 1)
              },
            },
          },
        });
        break;

      default:
        break;
    }
  };

  const customJoyrideStyles = {
    options: {
      // Change the font size of the content in the tooltip
      textColor: 'var(--bs-dark-blue)', // Change the text color (optional)
      zIndex: 1000, // Change the z-index (optional)
    },
    tooltip: {
      // Change the font size of the content in the tooltip
      fontSize: '18px',
    },
  };

  const steps = [
    {
      target: '.first-step',
      content: 'Here are your current credit scores, which we have directly obtained from your credit report. We will use these scores as a baseline to assess your initial credit standing and track the improvement in your scores over time by utilizing Disputely.',
      disableBeacon: true,
    },
    {
      target: '.second-step',
      title: 'Dispute Status',
      content: 'Here we have the status of your disputes.  They are broken into two categories, Dispute Letters and Dispute Items.',
    },
    {
      target: '.third-step',
      title: 'Dispute Items',
      content: 'Dispute Items are the individual accounts that are being disputed.',

      action: () => {
        const navLinkContainer = navLinkRef.current;

        navLinkContainer.click();
      },
    },
    {
      target: '.fourth-step',
      title: 'Dispute Items Table',
      content: (
        <>
          Here we have the table broken down into{' '}
          <ul className='text-start mt-3'>
            <li>Account Name</li>
            <li>Account #</li>
            <li>Account Type</li>
            <li>Account Status</li>
            <li>Reporting Date</li>
            <li>Dispute Date</li>
          </ul>
        </>
      ),
    },
    {
      target: '.fifth-step',
      title: 'Account Name',
      content: (
        <>
          <p>This is the company that owns the account</p>
          <img className='img-fluid' src='https://media.tenor.com/6xJ4csixkmMAAAAC/claimed-yup-thats-mine.gif' />
        </>
      ),
    },
    {
      target: '.sixth-step',
      title: 'Account Number',
      content: 'This is the account number 🔢 associated with the account you are disputing.',
    },
    {
      target: '.seventh-step',
      title: 'Account Type',
      content: 'This is the type of account. Typically this will be an Installment or a Revolving account, but it could also be a collection or a public record as well! 📚',
    },
    {
      target: '.account-status',
      title: 'Account Status',
      content: (
        <>
          <p>This is the current status of the account. Are you late? And if so, how many months? 30? 120? 180???</p>
          <p>When you said you were running behind, I was thinking 10 minutes not 6 months! But don't you worry... Disputely is here to save the day!</p>
        </>
      ),
    },
    {
      target: '.reporting-date',
      title: 'Reporting Date 📅',
      content: 'The Reporting Date gives the last date that this information was reported to the bureaus.',
    },
    {
      target: '.dispute-date',
      title: 'Dispute Month',
      content: 'This is the date that the account was disputed. Some accounts may take longer than others to remove, so this will populate dates as you start new cycles 🔄.',
    },
    {
      target: '.bureaus-dispute-items',
      title: 'Bureaus',
      content: (
        <>
          <p>These are the credit Bureaus! 🏦 These are the major bureaus that you will always have dispute letters for, no matter which plan you are on.</p>
          <p>However... being on an upgraded plan will not only guarantee that your letters get mailed faster than you can do it (we're on a first-name basis with the post office 📬), but disputing with some of the lesser-known bureaus can actually help your case with the big 3 (they're all bark 🐶).</p>
        </>
      ),
    },
    {
      target: '.eighth-step',
      title: 'Dispute Letters',
      content: 'Dispute Letters are the letters that have been sent to credit bureaus on your behalf 📨.',
      placement: 'left',
    },
    {
      target: '.ninth-step',
      content: 'Active letters are the letters that are currently being sent to the credit bureaus. You can see the letter status and the item count 📈.',
      placement: 'left',
    },
    {
      target: '.tenth-step',
      content: 'Complete letters are the letters that have been sent and are no longer active. You can see the date the letter was sent, the destination, and the item count ✅.',
      placement: 'left',
    },
    {
      target: '.eleventh-step',
      content: 'Tactic Style refers to the package you purchased and whether or not it includes Mailing. You can see the package style in the circle and the text below it 📦.',
      placement: 'left',
    },
    {
      target: '.twelfth-step',
      content: 'Here you can see the entire list 📝 of letters that have been generated 🤖 for you! , including the date they were created, the destination, the tactic style, the status, the item count, and the option to download the letter.',

      placement: 'left',
      event: 'joyride-click',
    },

    {
      target: '.thirteenth-step',
      title: 'Dispute Letter Table',
      content: 'The Dispute Letter table is broken down into the following columns: 📑',
    },
    {
      target: '.fourteenth-step',
      content: 'Date shows the 📅 date the letter was created. ',
    },
    {
      target: '.fifteenth-step',
      content: 'The "Destination" is basically "Where are my disputes going" (To the moon!🚀). The free "Standard" plan only sends out "Disputes" to the 3 major credit bureaus.',
    },
    {
      target: '.sixteenth-step',
      content: 'Tactic Style shows the package you purchased 🛍️ and whether or not it includes Mailing.',
    },
    {
      target: '.seventeenth-step',
      content: 'Status shows the current status 🟢 of the letter (Active or Complete).',
    },
    {
      target: '.eighteenth-step',
      content: 'Item Disputed shows the number of items being disputed in the letter.',
    },
    {
      target: '#download-all',
      title: 'Download All',
      content: (
        <>
          <p>Once your disputes are generated, it can be difficult to download each individuallly. To mitigate this, we have the... Drumroll please... </p>
          <img className='img-fluid' src='https://static.wixstatic.com/media/f2c85a_e450468441004db2a7fdd94b43c37fd9~mv2.gif' />
          <p> Download all button! (please clap) 👏. If you're on the Free plan and have decided to do the heaving lifting, here is where you will download the disputes to mail out to the bureaus.</p>
        </>
      ),
    },
    {
      target: 'body',
      title: <h2 className='mt-3'>Getting Started</h2>,
      placement: 'center',
      styles: {
        tooltip: {
          width: '50% !important', // Set the desired width for desktop
          '@media (max-width: 767px)': {
            width: '100%', // Set the desired width for mobile
          },
        },
      },
      content: (
        <span className=' w-100 w-md-50'>
          <p> Dispute Center is your own personal war room where you can see every aspect of the disputing process. 🛡️</p>
          <p>If you are on the free Standard plan, this is the most important step. If you don't mail your letters, you can't get results! Unless you're a magician... Do you do kids birthdays?</p>
          <img src='https://images.squarespace-cdn.com/content/v1/51158f93e4b04c436ed79f0d/1367200456213-TXJ3ST7BL50P5FW7PEAX/tumblr_m0p1h5mbIk1qeofff.gif?format=300w' alt='final countdown magician' style={{ width: '100%', maxWidth: '300px', marginBottom: '1rem' }} />

          <p>If you're thinking "I should have upgraded...", its not too late! Go take a second look at our plans and find one that makes your life easier AND your credit better!</p>
        </span>
      ),
    },
  ];

  const handleJoyrideCallback = data => {
    const { type, status, index, action } = data;

    // Check if the tour reaches the desired step (third step) and the action is "next"
    if (index === 2 && action === ACTIONS.NEXT) {
      // Programmatically click the Nav.Link for the third step
      navLinkRef.current.click();
    }

    // Add the condition for the twelfth step
    if (index === 11 && action === ACTIONS.NEXT) {
      // Programmatically click the Nav.Link for the twelfth step
      navLinkRefTwelfth.current.click();
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if (type === 'tour:end') {
        dispatch(updateTourProgress({ tour_name: 'dispute-center', completed: 1 }));
      }
      
    } else if (type === 'step:before') {
      if (index === 12) {
        // Programmatically click the Nav.Link for the twelfth step
        navLinkRefTwelfth.current.click();
      }
    } else if (type === 'step:after') {
      // ... (the rest of the function)
    }
  };

  useEffect(() => {
    const navLinkContainerTwelfth = navLinkRefTwelfth.current;

    const handleCustomEvent = event => {
      if (event.target.matches('.twelfth-step')) {
        navLinkContainerTwelfth.click();
      }
    };

    if (navLinkContainerTwelfth) {
      navLinkContainerTwelfth.addEventListener('joyride-click', handleCustomEvent);
    }

    return () => {
      if (navLinkContainerTwelfth) {
        navLinkContainerTwelfth.removeEventListener('joyride-click', handleCustomEvent);
      }
    };
  }, [navLinkRefTwelfth.current]);


  const documentUploadCallback = async (skipped=false) => {
    !skipped && dispatch(setSkipDocuments(0))
    notyf.open({
      type: 'success',
      message: "Letters are being generated, don't reload",
      duration: 6000,
      ripple: false,
      dismissible: false,
      position: {
        x: 'right',
        y: 'top',
      },
    });
    await dispatch(generateLetters())
    setShowDocumentsModal(false);
    setTimeout(() => {
      dispatch(blankUploadDocument())
      dispatch(blankGetAllReportData())
      dispatch(blankCurrentStatus());
      dispatch(blankStartCurrentScore())
      if(userCurrentInfo?.response?.current_plan === "2" || ( userCurrentInfo?.response?.current_plan === "1" && userCurrentInfo?.response?.mailing_option === "2" )) {  
        setShowRoundStartPopUp(true)
      }
    }, 5000);    
  }

  if (['loading', 'idle'].includes(sc_status) || ["loading", "idle"].includes(uploadDocumentStatus)) {
    return <Loader />;
  }



  return (
    <React.Fragment>
      <Helmet title='Dispute Center' />
      <style>
        {`

.content {

    align-items:start;
}
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
	color: var(--bs-nav-pills-link-active-color);
	background-color: #fff;
    border:#B3D6FF solid 3px
}
#activeLetter thead th {
    font-weight:300;
    padding: 1rem 2rem !important;
    border: solid transparent 0px;
}
#activeLetter {
  width: 100%;
  border-collapse: inherit;
  table-layout: fixed;
  text-align: center;
  font: 13px Verdana;
  border-radius: 30px;
  border-spacing: 0px;
  background: white;
  font-weight:300;
}

#activeLetter thead th {
  border: none;
  padding: 20px;
  background: #F8F9FD;
  color: var(--bs-gray-400);
  border-left: none;
}

#activeLetter thead tr {
background:white;
}

#activeLetter thead tr:first-child th:first-child {
  border-radius: 20px 0 0 20px;
}

#activeLetter thead tr:first-child th:last-child {
  border-radius: 0 20px 20px 0;
}

#activeLetter tbody th {
  padding: 20px;
}
#inDispute thead th {
padding: 1rem 2rem !important;
border: solid transparent 0px;
}
#inDispute {
width: 100%;
border-collapse: inherit;
table-layout: fixed;
text-align: center;
font: 13px Verdana;
border-radius: 30px;
border-spacing: 0px;
background: white;
}

#inDispute thead th {
border: none;
padding: 20px;
background: #F8F9FD;
color: var(--bs-gray-400);
border-left: none;
}

#inDispute thead tr {
background:white;
}

#inDispute thead tr:first-child td:first-child {
border-radius: 20px 0 0 20px;
}

#inDispute thead tr:first-child td:last-child {
border-radius: 0 20px 20px 0;
}

#inDispute tbody th {
padding: 20px;
}





/* Change the button background color */
.react-joyride__tooltip button {
  background-color: #0076FF !important; /* Change this to your desired color */
  border-color: #0076FF !important; /* Change this to your desired color */
}

/* Change the button hover background color */
.react-joyride__tooltip button:hover {
  background-color: #1b1848 !important; /* Change this to your desired hover color */
  border-color: #0076FF !important; /* Change this to your desired hover color */
}

/* Change the button properties */
.react-joyride__tooltip button[type="button"][data-action="back"] {
  appearance: none !important;
background-color: transparent !important;
border-style: none !important;
color: #0076FF !important;
cursor: pointer !important;
font-family: "Anek Bangla", sans-serif !important;
font-size: 16px !important;
font-weight: 400 !important;
line-height: 16px !important;
margin: 0 !important;
margin-right: auto !important;
padding: 8px !important;
text-align: center !important;
text-transform: none !important;
visibility: visible !important;


}

/* Change the button hover properties */
button[type="button"][data-action="back"]:hover {
 color: var(--bs-dark-blue) !important; 
  background-color: none !important; 
  
}

div[style*="align-items: center; display: flex; justify-content: flex-end; margin-top: 15px;"] > div {
  /* Override the style here */
  flex: inherit !important;
}


          `}
      </style>
      <Container fluid className='p-0 container-fluid-1335'>
        <Joyride showSkipButton={true} locale={{ last: 'FINISH' }} styles={customJoyrideStyles} steps={steps} run={runJoyride} continuous={true} scrollToFirstStep={true} showProgress={false} hideCloseButton callback={handleJoyrideCallback} disableOverlayClose={true} disableCloseOnEsc={true} />

        {sc_status === 'succeeded' && showRoundStartPopUp && uploadDocumentStatus === 'succeeded' && (
          <SuccessPopup
            startDate={startCurrentScore?.data?.round_start_date}
            endDate={startCurrentScore?.data?.round_end_date}
            setClosed={() => {
              delete state?.congratulations;
              delete window.history?.state?.congratulations;
              window.history.replaceState({}, document.title)
              setShowMailed(false);
              setShowRoundStartPopUp(false);
              
              dispatch(blankUploadDocument())
              dispatch(blankStartCurrentScore())
              dispatch(blankCurrentStatus())

            }}
            plan={userCurrentInfo?.response?.current_plan === '1' ? (userCurrentInfo?.response?.mailing_option === '1' ? 1 : 2) : 3}
          />
        )}

        {showDocumentsModal && <UploadAllDocument showDocumentsModal={showDocumentsModal} setShowDocumentsModal={setShowDocumentsModal} 
        callbacks={documentUploadCallback} isUpload={isDocUpload} />}


        <Row>
          {currentRound >= 2 && (
            <Col xs='12' md='8' lg='6' className='custom-col mb-md-3 mt-3 mt-md-4 mx-auto'>
              <h3 className='mb-4'>Starting Scores</h3>
              <Score
                scores={{
                  transunion: {
                    value: startScore.transunion,
                    label: startScore.transunionLabel,
                  },
                  equifax: {
                    value: startScore.equfix,
                    label: startScore.equfixLabel,
                  },
                  experian: {
                    value: startScore.experian,
                    label: startScore.experianLabel,
                  },
                }}
              />
            </Col>
          )}
          <Col xs='12' md='8' lg='6' className='custom-col mb-md-3 mt-3 mt-md-4 mx-auto first-step'>
            <h3 className='mb-4'>Current Scores</h3>
            <Score
              scores={{
                transunion: {
                  value: currentScore.transunion,
                  percent: currentRound >= 2 ? currentScore.transunionPresentage : null,
                  label: currentScore.transunionLabel,
                },
                equifax: {
                  value: currentScore.equfix,
                  percent: currentRound >= 2 ? currentScore.equfixPresentage : null,
                  label: currentScore.equfixLabel,
                },
                experian: {
                  value: currentScore.experian,
                  percent: currentRound >= 2 ? currentScore.experianPresentage : null,
                  label: currentScore.experianLabel,
                },
              }}
            />
          </Col>
        </Row>
        <Row className='mt-5'>
          <Col>
            
            <div className="d-flex justify-content-between align-items-center">
              <h3 className='mb-4'>Dispute Status</h3>
              { currentRound >= 2 && (currentStatusData?.current_status && currentStatusData?.current_status === 7) && 
                <div className="d-flex align-items-center justify-content-end col-6">
                  <CountdownTemplates notyf={notyf} status={"NEW_ROUND"} />
                </div>
              }
              
            </div>
            {/* {
              (dispute_letter_left_list.length > 0 && dispute_letter_left_list.filter(letter => letter.downloaded == "0").length > 0 ) && !dispute_letter_is_emailed && !sessionStorage.getItem("skip_letter_prompt") &&
              <StandardModal handleChoice={handleChoice} />
            } */}
            <Card className='border-0 rounded-3 shadow mb-0'>
              <Card.Body>
                <Tab.Container id='left-tabs-example' defaultActiveKey={activeTab} className='bg-white'>
                  <Nav variant='pills' className='row second-step'>
                    <Col md={6} xs={12} className='nav-item mx-auto'>
                      <NavItemComponent navRef={navLinkRefTwelfth} eventKey='first'>
                        <Row className='d-flex flex-md-row flex-column justify-content-between'>
                          <Col lg={5} className='pe-md-5 pe-0 ms-auto d-flex flex-column mb-3 mb-md-0 flex-md-row justify-content-start align-items-center'>
                            <div className='mb-3 mb-md-0'>
                              <div className='d-flex bg-primary rounded-circle' style={{ borderRadius: '50%', height: '40px', width: '40px' }}>
                                <Mail className='m-auto text-white' width={20} height={20} strokeWidth={2} />
                              </div>
                            </div>
                            <h1 className='h1 mb-0 mx-3'>{dispute_letter_left}</h1>
                            <div className='text-regular-16 lh-1 text-dark-blue fw-light d-flex'>
                              Dispute
                              <br />
                              Letters
                              <InfoPopover
                                headerContent='Track Your Dispute Letters!'
                                bodyContent={
                                  <>
                                    <p>Keep track of all the dispute letters you generate in this section of your Dispute Center!</p>
                                    <p>All letters generated whether Standard or Enhanced will be listed below</p>
                                    <p>Active Letters will be considered any letters that are currently being used for disputes that are ongoing</p>
                                    <p> Complete Letters will be considered any letters that have already been used for disputing and have completed their 35-45 day cycle.</p>
                                  </>
                                }
                              />
                            </div>
                          </Col>
                          <Col className='col-auto ps-5 border-start' />
                          <Col lg={5} className='me-auto d-flex justify-content-start align-items-center'>
                            <table className='py-0 m-auto position-relative left-0 text-dark table table-borderless' border='0'>
                              <tbody>
                                <tr>
                                  <td className='py-0 px-0'>
                                    <div className='d-flex'>
                                      <div>
                                        <span style={{ fontSize: '0px', fontWeight: 300 }} className='d-inline-flex bg-success p-1 rounded-circle mx-auto me-2'></span>
                                      </div>
                                      <div className='text-normal-16 fw-light my-auto text-dark-blue'>Active Letters</div>
                                    </div>
                                  </td>
                                  <td className='py-0 px-0 ps-2'>{active_letter}</td>
                                </tr>
                                <tr>
                                  <td className='py-0 px-0'>
                                    <div className='d-flex'>
                                      <div>
                                        <span style={{ fontSize: '0px', fontWeight: 300 }} className='d-inline-flex bg-primary p-1 rounded-circle mx-auto me-2'></span>
                                      </div>
                                      <div className='text-normal-16 fw-light my-auto text-dark-blue'>Complete Letters</div>
                                    </div>
                                  </td>
                                  <td className='py-0 px-0 ps-2'>{completed_letter}</td>
                                </tr>
                                <tr className='visibility-hidden'>
                                  <td className='py-0 px-0'>
                                    <div className='d-flex'>
                                      <div className='text-normal-16 fw-light my-auto text-dark-blue'></div>
                                    </div>
                                  </td>
                                  <td className='py-0 px-0 ps-2'>&nbsp;</td>
                                </tr>
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      </NavItemComponent>
                    </Col>
                    <Col md={6} xs={12} className='nav-item mx-auto'>
                      <NavItemComponent navRef={navLinkRef} eventKey='second'>
                        <Row className='d-flex flex-md-row flex-column justify-content-between'>
                          <Col lg={5} className='pe-md-5 pe-0 ms-auto d-flex flex-column mb-3 mb-md-0 flex-md-row justify-content-start align-items-center'>
                            <div className='mb-3 mb-md-0'>
                              <div className='d-flex bg-primary rounded-circle' style={{ borderRadius: '50%', height: '40px', width: '40px' }}>
                                <Mail className='m-auto text-white' width={20} height={20} strokeWidth={2} />
                              </div>
                            </div>
                            <h1 className='h1 mb-0 mx-3'>{dispute_letter_right}</h1>
                            <div className='text-regular-16 lh-1 text-dark-blue fw-light d-flex'>
                              Dispute
                              <br /> Items
                              <InfoPopover
                                headerContent='Track Your Results!'
                                bodyContent={
                                  <>
                                    <p>Keep track of the statuses of all of your disputed items in this section of the Dispute Center! </p>
                                    <p>See status key to view what each status means : insert key In dispute items will be considered all items that are currently being disputed on your credit reports </p>
                                    <p>Deleted/Repaired items will be considered all items that have been removed and/or corrected after being disputed. </p>
                                    <p>A deleted status will signify the complete deletion of an item that was reporting negative on your credit report. </p>
                                    <p>A repaired status will signify the correction/removal of negative information that was on your credit report, however the account itself still remains on your credit report, but now it is in good standing.</p>
                                  </>
                                }
                              />
                            </div>
                          </Col>
                          <Col className='col-auto ps-5 border-start' />
                          <Col lg={5} className='me-auto d-flex justify-content-start align-items-center'>
                            <table className='py-0 m-auto position-relative left-0 text-dark table table-borderless' border='0'>
                              <tbody>
                                <tr>
                                  <td className='py-0 px-0'>
                                    <div className='d-flex'>
                                      <div>
                                        <span style={{ fontSize: '0px', fontWeight: 300 }} className='d-inline-flex bg-success p-1 rounded-circle mx-auto me-2'></span>
                                      </div>
                                      <div className='text-normal-16 fw-light my-auto text-dark-blue'>In Dispute</div>
                                    </div>
                                  </td>
                                  <td className='py-0'>{disputeItemCounts.in_dispute}</td>
                                </tr>
                                <tr>
                                  <td className='py-0 px-0'>
                                    <div className='d-flex'>
                                      <div>
                                        <span style={{ fontSize: '0px', fontWeight: 300 }} className='d-inline-flex bg-primary p-1 rounded-circle mx-auto me-2'></span>
                                      </div>
                                      <div className='text-normal-16 fw-light my-auto text-dark-blue'>Deleted / Repaired</div>
                                    </div>
                                  </td>
                                  <td className='py-0'>{disputeItemCounts.deteled_letter}</td>
                                </tr>
                                <tr>
                                  <td className='py-0 px-0'>
                                    <div className='d-flex'>
                                      <div>
                                        <span style={{ fontSize: '0px', fontWeight: 300 }} className='d-inline-flex bg-danger p-1 rounded-circle mx-auto me-2'></span>
                                      </div>
                                      <div className='text-normal-16 fw-light my-auto text-dark-blue'>Negative / Verified</div>
                                    </div>
                                  </td>
                                  <td className='py-0'>{disputeItemCounts.verified_items}</td>
                                </tr>
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      </NavItemComponent>
                    </Col>
                  </Nav>
                  <Tab.Content className='mt-5'>
                    <Tab.Pane eventKey='first'>
                      <ActiveLetter currentStatus={currentStatusData?.current_status} setIsDocUpload={setIsDocUpload} currentRound={currentRound} documentUploadCallback={documentUploadCallback} setShowDocumentsModal={setShowDocumentsModal} setDocumentPopUp={setDocumentPopUp} documentPopUp={documentPopUp} dispute_letter_left_list={dispute_letter_left_list} dispute_letter_current_plan_id={dispute_letter_current_plan_id} />
                    </Tab.Pane>
                    <Tab.Pane eventKey='second'>
                      <InDispute dispute_letter_right_list={dispute_letter_right_list} />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal centered size={!dispute_letter_is_emailed ?'lg' : 'md'} show={showUpgradeModal} onHide={() => setShowUpgradeModal(false)}>
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <EnhanceCurrentDisputes disputelyMailed={dispute_letter_is_emailed} />
        </Modal.Body>
      </Modal>

      <Modal centered size='md' show={showGenerateRoundResult && !showRoundStartPopUp} onHide={() => setShowGenerateRoundResult(false)} backdrop="static" keyboard={false} enforceFocus={false}>
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <CountdownTemplates notyf={notyf} status={"GENERATE_RESULTS"} callback={() => {
            // navLinkRef.current?.click()
            setActiveTab("second")
            setShowGenerateRoundResult(false)
          }} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default DisputeCenter;
